import { css } from '@emotion/react';
import { colors } from '@zapier/marketing-ui';

const styles = {
  root: css({
    alignItems: 'center',
    display: 'flex',
  }),

  separator: css({
    borderTop: `1px solid ${colors.neutral300}`,
    height: 0,
    width: '100%',
  }),

  text: css({
    color: colors.neutral700,
    padding: '0 20px',
  }),
};

export function SocialOptionsSeparator() {
  return (
    <div css={styles.root} data-testid="login-separator">
      <hr css={styles.separator} />
      <span css={styles.text}>OR</span>
      <hr css={styles.separator} />
    </div>
  );
}
